import { useMap } from 'react-leaflet';
import { useEffect, useRef } from 'react';

const ChangeMapCenter = ({ center }) => {
    const map = useMap();
    const previousCenter = useRef(null);

    useEffect(() => {
        const hasCenterChanged =
            !previousCenter.current ||
            previousCenter.current[0] !== center[0] ||
            previousCenter.current[1] !== center[1];

        if (hasCenterChanged) {
            console.log("Map center changed, updating view:", center);
            map.flyTo(center, map.getZoom(), { animate: true }); // Smoothly fly to the new center
            previousCenter.current = center;
        } else {
            console.log("Map center has not changed:", center);
        }
    }, [center, map]);

    return null;
};

export default ChangeMapCenter;
